import { render, staticRenderFns } from "./surveysQuestions.vue?vue&type=template&id=f5a30204&"
import script from "./surveysQuestions.vue?vue&type=script&lang=js&"
export * from "./surveysQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports